import { useEffect } from 'react'

import { i18WithDefault as t } from '@shared/locale'
import { ContactToBookContent } from './contact_to_book_content'

export const ContactToBook = () => {
  useEffect(() => {
    document.title = t('contactToBook.title')
  }, [])

  return <ContactToBookContent />
}
